import { Component, Input, EventEmitter, Output, OnInit } from "@angular/core";
import * as Survey from "survey-angular";
import * as widgets from "surveyjs-widgets";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import CryptoJS from 'crypto-js';
import { QuizService } from '../../Service/Quizservice';
import { init as initCustomWidget } from "./customwidget";
import { Router, UrlSerializer } from "@angular/router";
import * as SurveyPDF from "survey-pdf";
import { jsPDF, jsPDFOptions } from 'jspdf';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';

export enum HorizontalAlign {
  NotSet = "notset",
  Left = "left",
  Center = "center",
  Right = "right"
}
widgets.icheck(Survey);
widgets.select2(Survey);
widgets.inputmask(Survey);
widgets.jquerybarrating(Survey);
widgets.jqueryuidatepicker(Survey);
widgets.nouislider(Survey);
widgets.select2tagbox(Survey);
widgets.sortablejs(Survey);
widgets.ckeditor(Survey);
widgets.autocomplete(Survey);
widgets.bootstrapslider(Survey);
widgets.prettycheckbox(Survey);
initCustomWidget(Survey);

Survey.JsonObject.metaData.addProperty("questionbase", "popupdescription:text");
Survey.JsonObject.metaData.addProperty("page", "popupdescription:text");
Survey
  .JsonObject
  .metaData
  .addProperty("question", { name: "score1:number" });

Survey.JsonObject.metaData.addProperty("itemvalue", { name: "score1:number" });

Survey.StylesManager.applyTheme("default");

 
@Component({
  // tslint:disable-next-line:component-selector
  selector: "survey",
  template: `<div class="survey-container contentcontainer codecontainer">
    <div id="surveyElement"></div>
  </div>`,
})
export class SurveyComponent implements OnInit {
  @Output() submitSurvey = new EventEmitter<any>();
  @Input() json: object;
  result: any;
  count1: any = 0;
  studentid:any;
  totquizscore = 0;
  studentscoretotal = 0;
  public marks=[];
  public marks1 = [];
  public obtainedMarks = [];
  public marksdata1 = [];
  httpHeaders: HttpHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*'
  });

  constructor(private QuizService: QuizService, private router: Router, private http: HttpClient) {
    this.studentid = sessionStorage.getItem("sid");
    

  }
  ngOnInit() {

    const surveyModel = new Survey.Model(this.json);
    const surveyModel1 = new Survey.Model(this.json);
    surveyModel1.data = {
      self: this,
    };

    
    surveyModel.onAfterRenderQuestion.add((survey, options) => {
      
      if (!options.question.popupdescription) {
        return;
      }
     
      // Add a button;
      const btn = document.createElement("button");
      btn.className = "btn btn-info btn-xs";
      btn.innerHTML = "More Info";
      btn.onclick = function () {
        // showDescription(question);
        alert(options.question.popupdescription);
      };
      const header = options.htmlElement.querySelector("h5");
      header.closest("h5").style.margins="10px";
      const span = document.createElement("span");
      span.innerHTML = "  ";
      header.appendChild(span);
      header.appendChild(btn);
      
    });
    surveyModel.onComplete.add((result, options) => {
      console.log("Result" + JSON.stringify(result.data))
      this.submitSurvey.emit(result.data);
      var marksdata = this.calculatemarks1(this.json, surveyModel.data);
      var totalScore = 0;
      var data = result.data;
      var totquizscore1 = 0;
      var questions = surveyModel.getAllQuestions();
      questions.forEach(function (question) {
        var qName = question.name;
        var qValue = data[qName] || '';
        var questionno = qName.split("question")[1];
        var questionmarks = marksdata[qName];//
        console.log("Question Marks "+questionmarks);
        console.log("question" + question)
        if (JSON.stringify(question.correctAnswer) === JSON.stringify(qValue) && surveyModel.data != null) {
          totalScore += parseInt(questionmarks, 10);
          totquizscore1 += parseInt(questionmarks, 10);
        } else if (question.isAnswerCorrect() && surveyModel.data != null) {
          totalScore += parseInt(questionmarks, 10);
          totquizscore1 += parseInt(questionmarks, 10);
        } else {
          totquizscore1 += parseInt(questionmarks, 10);
        }
        console.log("totquizscore1"+totquizscore1)
      });
      var updatejson = {
       
        quizid: CryptoJS.AES.decrypt(this.studentid.trim(), 'q').toString(CryptoJS.enc.Utf8),
        submittedans: JSON.stringify(result.data, null, 3),

        Percentage: ((totalScore / totquizscore1) * 100).toFixed(2),
        Score: totalScore + '/' + totquizscore1,
        Submitteddate: new Date().toLocaleString()
      }
      this.QuizService.updatestudentsubmitteddata(JSON.stringify(updatejson))
        .subscribe(data => (JSON.parse(JSON.stringify(data))['status']));
      surveyModel1.data = result.data;
      console.log("totalScore"+totalScore);
      console.log("totquizscore1"+totquizscore1)
    });
   
    surveyModel.onCompleting.add((options) => {
      sessionStorage.setItem("isQuizSubmitted", "1");
      surveyModel1.mode = 'display';
       marksdata1 = this.calculatemarks1(this.json, surveyModel.data)
      var node = document.createElement("span");
      var totmarks = 0;
      var studmarks = 0;
      var obtainedMarks = [];
      node.style.cssFloat = "right";
      node.style.fontWeight = "600";
      console.log(options)
      surveyModel1
        .onAfterRenderQuestion
        .add(function (survey, options) {
         
          setTimeout(function () {
            var qnoval = options.question.name.split("question")[1];
            var span = document.createElement("span");


            var isCorrect = options
              .question
              .isAnswerCorrect();
            span.innerHTML = isCorrect
              ? "(Correct) &nbsp; &nbsp;" + marksdata1[options.question.name] + " Out Of " + marksdata1[options.question.name] + "&nbsp; &nbsp;"
              : "(Incorrect) &nbsp; &nbsp;" + 0 + " Out Of " + marksdata1[options.question.name]+ "&nbsp; &nbsp";
            span.style.color = isCorrect
              ? "green"
              : "black";
            span.style.cssFloat = "right";
            span.style.padding = "2px 5px 0px";
            span.style.padding="0px 0"
            var header = options
              .htmlElement
              .querySelector("h5");
              var Clsdiv=header.closest('div');
              var Clsdivs=header.closest('div');
              console.log(Clsdiv);
            var jsonobj = JSON.parse(sessionStorage.getItem('editjson'))["pages"][0]["elements"];
            Clsdiv.style.padding = "5px 0 0 8px";
            Clsdiv.style.margin="6px 0"
            if (!isCorrect&&surveyModel1.data==null) {
              Clsdivs.style.backgroundColor = "salmon";
              var radio = options
                .htmlElement
                .querySelector('input[value="' + options.question.correctAnswer + '"]');
              totmarks = totmarks + parseInt(marksdata1[options.question.name]);
              if (!!radio&& surveyModel.data==null) {
                radio.parentElement.style.color = "green";
                radio.parentElement.value = "green";
              }
            }
            else {
              
              var qnv = options.question.name.split("question")[1];
              if (JSON.stringify(survey.data[options.question.name]) == JSON.stringify(options.question.correctAnswer) && surveyModel.data != null) {
                var questionName = options.question.name;
                var obtainedMark = marksdata1[questionName]
                obtainedMarks[questionName] = obtainedMark;
                studmarks = studmarks + parseInt(marksdata1[options.question.name]);
                totmarks = totmarks + parseInt(marksdata1[options.question.name]);
                span.innerHTML = "(Correct) &nbsp; &nbsp;" + marksdata1[options.question.name] + " Out Of " + marksdata1[options.question.name] + "&nbsp; &nbsp;"
                Clsdiv.style.backgroundColor = "greenyellow";
              }
              else if (isCorrect && surveyModel.data!=null){
                studmarks = studmarks + parseInt(marksdata1[options.question.name]);
                totmarks = totmarks + parseInt(marksdata1[options.question.name]);
                span.innerHTML = "(Correct) &nbsp; &nbsp;" + marksdata1[options.question.name] + " Out Of " + marksdata1[options.question.name] + "&nbsp; &nbsp;"
                Clsdiv.style.backgroundColor = "greenyellow";
              }
              else {
                span.innerHTML = "(Incorrect) &nbsp; &nbsp;" + 0 + " Out Of " + marksdata1[options.question.name]+ "&nbsp; &nbsp";
                Clsdivs.style.backgroundColor = "salmon";
                totmarks = totmarks + parseInt(marksdata1[options.question.name]);
                span.style.color = "black"
              }

            }
            localStorage.setItem('marksdata', marksdata1[options.question.name]);
            node.innerHTML = "Total Quiz Marks: " + studmarks + " Out Of " + totmarks;
            document.getElementById("descriptiondiv").appendChild(node);
            localStorage.setItem('totalMarks', String(studmarks));

            header.appendChild(span);
            var logoele = (document.getElementsByClassName("sv_header")[1]) as HTMLElement;
           // logoele.style.display = "none";
          }, 500)
        });
      Survey.SurveyNG.render("surveyResult", { model: surveyModel1 });

    })
    if (sessionStorage.getItem('ReviewOrgJson1') != undefined && this.router.url.indexOf('/std') == 0) {
      surveyModel.data = JSON.parse(sessionStorage.getItem('ReviewOrgJson1'));
      var marksdata1 = this.calculatemarks1(this.json, surveyModel.data)
      var node = document.createElement("span");
      var totmarks = 0;
      var studmarks = 0;
      node.style.cssFloat = "right";
      node.style.fontWeight = "600";
      surveyModel.mode = 'display';
      surveyModel.onAfterRenderQuestion
        .add(function (survey, options) {
       
          var span = document.createElement("span");
          // console.log(qnoval)
          /*var isCorrect = options.question.isAnswerCorrect();*/
          var isCorrect = options.question.isAnswerCorrect();

          // Use case-sensitive comparison for single text input
          if (options.question.inputType === 'text') {
            var userAnswer = options.question.value;
            var correctAnswer = options.question.correctAnswer;

            // Compare user answer with correct answer
            isCorrect = (userAnswer === correctAnswer);
          }

          localStorage.setItem("marksdata", marksdata1[options.question.choices]);

          span.innerHTML = isCorrect
            ? "(Correct) &nbsp; &nbsp;" + marksdata1[options.question.choices] + " Out Of " + marksdata1[options.question.name] + "&nbsp; &nbsp;"
            : "(Incorrect) &nbsp; &nbsp;" + 0 + " Out Of " + marksdata1[options.question.name] + "&nbsp; &nbsp";
          localStorage.setItem("marksdata", marksdata1[options.question.choices]);
          span.innerHTML = isCorrect
            ? "(Correct) &nbsp; &nbsp;" + marksdata1[options.question.choices] + " Out Of " + marksdata1[options.question.name] + "&nbsp; &nbsp;"
            : "(Incorrect) &nbsp; &nbsp;" + 0 + " Out Of " + marksdata1[options.question.name]+ "&nbsp; &nbsp";
          span.style.color = isCorrect
            ? "green"
            : "black";
          span.style.cssFloat = "right";
          span.style.padding = "2px 5px 0px";
          
          var header = options
            .htmlElement
            .querySelector("h5");
            var Clsdiv=header.closest('div');
            console.log(Clsdiv+"  2")
          var jsonobj = JSON.parse(sessionStorage.getItem('ReviewOrgJson'))["pages"][0]["elements"];
          Clsdiv.style.padding = "5px 0 0 8px";
          Clsdiv.style.margin="6px 0"
          var Clsdivs=header.closest('div');
          if (!isCorrect&&surveyModel.data==null) {
            header.style.backgroundColor = "salmon";
            var radio = options
              .htmlElement
              .querySelector('input[value="' + options.question.correctAnswer + '"]');
            totmarks = totmarks + parseInt(marksdata1[options.question.name]);
            if (!!radio&& surveyModel.data==null) {
              radio.parentElement.style.color = "green";
              radio.parentElement.value = "green";
            }
          }
          else {
            if (JSON.stringify(survey.data[options.question.name]) == JSON.stringify(options.question.correctAnswer)&& surveyModel.data!=null) {
              studmarks = studmarks + parseInt(marksdata1[options.question.name]);
              sessionStorage.setItem("studmarks", studmarks.toString());
              totmarks = totmarks + parseInt(marksdata1[options.question.name]);
              sessionStorage.setItem("totmarks", totmarks.toString());
              span.innerHTML = "(Correct) &nbsp; &nbsp;" + marksdata1[options.question.name] + " Out Of " + marksdata1[options.question.name] + "&nbsp; &nbsp;"
              Clsdiv.style.backgroundColor = "greenyellow";
            }
            else if (isCorrect&& surveyModel.data!=null) {
              studmarks = studmarks + parseInt(marksdata1[options.question.name]);
              sessionStorage.setItem("studmarks", studmarks.toString());
              totmarks = totmarks + parseInt(marksdata1[options.question.name]);
              sessionStorage.setItem("totmarks", totmarks.toString());
              span.innerHTML = "(Correct) &nbsp; &nbsp;" + marksdata1[options.question.name] + " Out Of " + marksdata1[options.question.name] + "&nbsp; &nbsp;"
              
              Clsdiv.style.backgroundColor = "greenyellow";
            }
            else {
              span.innerHTML = "(Incorrect) &nbsp; &nbsp;" + 0 + " Out Of " + marksdata1[options.question.name]+ "&nbsp; &nbsp";
              Clsdivs.style.backgroundColor = "salmon";
              totmarks = totmarks + parseInt(marksdata1[options.question.name]);
              span.style.color = "black"
            }

          }
          header.appendChild(span);
          node.innerHTML = "Total Quiz Marks: " + studmarks + " Out Of " + totmarks;
          sessionStorage.setItem("totmarks", totmarks.toString());
          document.getElementById("descriptiondiv").appendChild(node);
        });
    }
    else if (sessionStorage.getItem('Td') != undefined) {
      surveyModel.mode = 'display';
      var totscoreval = 0;
      var value = JSON.parse(sessionStorage.getItem('jsondata'));
      var json = value["pages"][0]["elements"];
      var totscoreval = 0;
      if (json != undefined) {
        for (var i = 0; i < json.length; i++) {
          if (json[i]["Marks"] != undefined) {
            totscoreval += parseInt(json[i]["Marks"]);
          }
          else {
            totscoreval += parseInt("1");
          }

        }
        setTimeout(function () {
          var node1 = document.createElement("span");
          node1.style.cssFloat = "right";
          node1.style.fontWeight = "600";
          node1.innerHTML = "Total Quiz Marks: ____ Out Of " + totscoreval;
          document.getElementById("descriptiondiv").appendChild(node1);
        }, 500);
      }
    }
    var pdfWidth = surveyModel.pdfWidth || 210;
    var pdfHeight = surveyModel.pdfHeight || 297;
    var pdfoptions = {
      format: [pdfWidth, pdfHeight],
    };
    var surveyPDF = new SurveyPDF.SurveyPDF(JSON.parse(sessionStorage.getItem('ReviewOrgJson')), pdfoptions);
    surveyPDF.mode = 'display';
    surveyPDF.data = JSON.parse(sessionStorage.getItem('ReviewOrgJson1'));
    var marksdata1 = this.calculatemarks1(this.json,surveyPDF.data)
    console.log(this.marks1);

    surveyPDF
        .onRenderFooter
      .add(function (survey, canvas) {
        canvas.drawText({text: " Copyright © 2022 ExcelSoft Technologies Pvt.Ltd. All rights reserved", fontSize: 10});
        canvas.drawImage({
            base64: "data:image/png;base64,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",
      horizontalAlign:HorizontalAlign.Left,
      width: (canvas.rect.yBot - canvas.rect.yTop) * 3.5,
      height: (canvas.rect.yBot - canvas.rect.yTop) * 5,
      margins: {
        right: (canvas.rect.yBot - canvas.rect.yTop) ,
        left:40
      }
        });
        canvas.drawText({
          text: canvas.pageNumber + '/' + canvas.countPages,
          fontSize: 10,
          horizontalAlign: HorizontalAlign.Right,
          margins: {
            right: 12
          }
        });
      });
    surveyPDF
      .onRenderHeader
      .add(function (survey, canvas) {
        canvas.drawImage({
           base64: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALQAAAA8CAYAAADPLpCHAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAACadJREFUeNrsXL1y4zYQhh0XSRVekZl0R5cpMid36Sw/geUyaSx16SQ9ga0nkNylk9wkk0ryE5h+AusmRZLKcpciM9FVSZldeXG3hwAgCJL6y34zHMkWCYLEh8W3iwWUEggEAoFAIBAIBEVwUEUh3z7/ncBHE44GHG/gSNjPtz+9/mxC593DxwKOZzjmcGTw21KaQVAVjkoSuQ0f53C0PKc9sO9NSxlI7Fs4ZkDuhTSJYO2EBhJew0fXsMSxaNAxhHJn8HkDxM6kaQS1ExoIhxZ2DEdaU33Q0reI2H2x2IKiOCxole8jyJxFEvuRJI1AUC2hgVhola8iiHxhyId5getRzozp3gJBEA4CyVzYUgKRDxxOZAxBdeeQiIgg3kLHkpldn6BU0dKBwneTiKKaJHcEgjgLDSRMIzUzt6pN+o6W9QwIPWfOpf7tVFnCeQ5MoIyONJugjORokH5ulbzXR6Q2nM0i+hyjHyNpOkGUU4gEhOMCvpa1jAlFLsZkoWMxpE4mEORbaJIaTxSRwGOg48EBTl2frllNlNRYb+xkJ1UW+Pqr7xrqw0TR8vnXH+ebahSoC46GXTayDTZZn10ntM0R7LB8jKlHfqzOo07xqKqZSVS+e5UkDj6nb+p+NXMJZMrWSOYGvTuOBdThWOhaUHJQkpEtqjFmw3zfU94lyRS06ChTFjXW/aoMaeB4pNHG5xvgb/dwLh7JmtrEVp8U7t8UuhbX0K08AhFZXcNfE4jfo/Mwk+4Y49H6CKjPAI4T+sxDCvdqxZBZvURviuhwJNMTXVs3FgX/L/AQ+jzQcmQ5TtuQrH1hkBN6TcTOm0i5LEjmlMgcUze8ZroGSz2zGIwJSA4hdFENDST8K6exteUMiR3PKDqiHc22IRN0p0jVh1h3Rk5oRtc1SRboxmxY6vcqdAYRpYOj3kigG3aflOqaWs5FctUeCyfHEJ93Jg5hBKFZdKMqYMw58ziIKEcWjsjJCH7rWxxWGyFxSnwWQJCmss82WglKltglTY7FYm4WZOzuOdfwC08fTau8IUtKcuVNY4UmFBXpMuLMAjW0YqPFLOC8rkOXWp1cIOwSSH3h6Ixdfh2cN7QQ/xbKmDhGCRN9bYVJpw8t9TnLuV8QeDkOckQZrm0h+lHJ6+ckE96ZkQeypsrz4lcJ/SgXMKZMDl7CQ3FsRUziKSu0YW0OJIbklp7GXwB5ZpbIT8voCA3LyPHgcTBt+px/z5NzDRWeLvC/wlEEMRQ5a2ZqKBLwKqfhzEa8h2vOiNQzVg7WZRo4auTW2xPyCrHsdxZCYxgt8XWGHQMapjOH062fva/s0a35thJ6XuThuSNGOjlGsiAZn+D6gc7PIDIXiUQksaQP1MGZp8xsB4lrk4dL27MYKQrzXVgaZxJ6GUCQjiYzhueoB5cJZSXG9VNV/QxjUoCoNi29be1265E0Lr8F26z26AwZpJbhp8xCIlEkOxtGJ5pFERpvCAX2lT9XY8JSQEvlSpvlMs2cqt3AxuppczaZvLp2dOB+neE/mneYOqTmkI/Cjk5glZjw28pxDyX2kTH0YMQhU+4Y7I0hMSoZgthi2MrK3GdC5/gKtpSAia8TVERmHuJcUDumRPCESJ3QpJlJZi4xdVKc3g0Ay5jCeUHh2SMHuToBBDyr+sWYD7vlWGwZmbWFtOnmfs2352HEjxZhGAtFrtBgGlqcS8yOEeVqst/HdO0yiND0QnwRg0XsZAJOOZeZiDBSO63OTkTEId0nQjt8j1U0qs5ojJHQlpkrimjyTMfzdeQkY5pZt8PAzJ6kibkBdRh9H+/ijkPDa7/3HGX0Moa5yuRBDHPqllfuPJbQlP+x1aCJFpt27axhRrNlOKu2kXfO2oCff276UZZrOYFP8ypzWKDin5dwYjLdYerIWAtotIVHc+ah6XmmbSAzEqRn+WkEdZytoQppYOTozhJx0tcuczYVykKN0KExPPlQloi3jNTNgtc2SxJ+7ni+kGy9y0CLvwkyp46oFEqw/rrrE7rTlWUJXuj7bAQTOiCk0yyZOjlhPRRJ3SvguauA3ht6f462b8SgezcdnVMVMAZr18075lCH8moZTOjAnhK98ptkAR8Ch0CYcUAnOY/QxzbcOP4/tpGa/jd1vFSzc7y1nHfqKLNK3dzYkG62kixn8fMbiyVfBlreRmhbH1msXSNn+J2UlB28U6CjicuhLmyNQGTPc0bfhnYoKG9k0ZurNXzwGz7XM3v5rs47sEQNlo4Rbci0IzZ2t2bdvKD36WvDqhcLZAY/MkckpGkh5YN+zzipZlsjSp0kCSW0aaEfAmRHtJ4lJ2XhIFSDNxhab/iat+BAqbAEo/dk9LwU7DhXyr8HCSbbjwrUocciMVequin9scdBu8o5Ko3aUARDk7jtsNJD9uw3hgzUxuA/q5zo72HAKGsnNBEuT6eU3Z7A1vgJkRqH/yca6tshZRWJsdK5Z5FOHTZaxyOnJmp9SNR2gTug97QED9eXtimNWLflnFthmiQZsGfCRLUeXYvG4JEphlGI03lYQGu+t6iULxALX/ntghbkNmKUwD039ELcIs5cXg5yP6CjZGrL0i0rtNIX7H3qkWnM3lmmLLPLFGfmpNZzDkPGBesKJhsOHKGgkKVYndj8AM/avkKectm9KphGP6WXx3MRUo+GvvaU2SYtqWc3F0TiO3xfbK2gVdfS+29bOuI1u0cZgxKsoY09CCd5FpKmubvG8yHJ7/L2UKFrTUmE97u1pa2ydaof1e3A40H36iI1NXrZfZ87dSbcUFhx6LG0F3uU4L83OPQ4TyGNNQ6NJxvWZqLKxW6zOslMdRzRELncAQ0r8BGaLE9oMviQdhYq6j3HTsuuJVGd3gNa4hND9+KQfSLWeTvxieuHd3/+8lvyxdepCpvyxvN6eD4cz3DtH7luOpwHH99H1PkHINPP63pB8CxLqCve70v1MqUs+1NvMXK356I94IrOcC1IZ761ePXoZLxWL7HemKFbNi4UlCK0b8OVTeFsW7LdBLvhFJp6OnYyoi5cStMJoghtkHqyJfVurXF7W8E+OIUW5+gfOO7AQcJdkr6B49Oa64Y6vE+a27wX/v071Ec2MRQUt9CGtcb47EnN1nq1TzTFmo8dcqcrzSco7BTmOIypepmubFdQF51nfONIJbXtA3IiW80KKiM0IxvPiWgVJDFOsDyEzPxZpqNHm1hqJNhzQluIpzcIcYX6MhW5LQLlY+ulR5g590qaUVAroesGSZ0pdZhO3Xkdgj12CrcBZNl1GFFi0oL9AeYGS0xaIBAIBAKBQLBG/CvAAFfHSgi/6awYAAAAAElFTkSuQmCC",
        
     horizontalAlign:HorizontalAlign.Left,
     width: (canvas.rect.yBot - canvas.rect.yTop) * 4.5,
     height: (canvas.rect.yBot - canvas.rect.yTop) * 6,
     margins: {
       right: (canvas.rect.yBot - canvas.rect.yTop) 
     }
       });
        //canvas.drawText({text: "Reports", fontSize: 10});
        canvas.drawText({
          text: canvas.pageNumber + '/' + canvas.countPages,
          fontSize: 10,
          horizontalAlign: HorizontalAlign.Right,
          margins: {
            right: 12
          }
        });
      });
    surveyPDF
      .onRenderQuestion
      .add(function (survey, options) {

        var plainBricks = options
          .bricks[0]
          .unfold();
        var lastBrick = plainBricks[plainBricks.length - 1];
        var point = SurveyPDF
          .SurveyHelper
          .createPoint(lastBrick);
        //point.yTop = point.yTop - 40;
        //point.xLeft = point.xLeft+450; 
        if (options.question.getType() == "text" || options.question.getType() == "imagepicker" || options.question.getType() == "dropdown" || options.question.getType() == "boolean") {
          options.point.yTop += options.controller.unitHeight / 2;
          point.yTop += options.controller.unitHeight - 10;

        }
        else {
          options.point.yTop += options.controller.unitHeight / 2;
          point.yTop += options.controller.unitHeight + 30;
        }
        var dataval;
        if (options.question.isAnswerCorrect()&& surveyModel.data!=null) {
          dataval = "(Correct)"
        }
        else {
          dataval = "(Incorrect)"
        }
        if (!options.question.isAnswerCorrect()&& surveyModel.data==null) {

          totmarks = totmarks + parseInt(marksdata1[options.question.name]);
          dataval = "(Score) " + 0 + " Out Of " + marksdata1[options.question.name];
        }
        else {
          var qnv = options.question.name.split("question")[1];
          if (JSON.stringify(survey.data[options.question.name]) == JSON.stringify(options.question.correctAnswer)&& surveyModel.data!=null) {
            studmarks = studmarks + parseInt(marksdata1[options.question.name]);
            totmarks = totmarks + parseInt(marksdata1[options.question.name]);
            dataval = "(Score) " + marksdata1[options.question.name] + " Out Of " + marksdata1[options.question.name];

          }
          else {
            dataval = "(Score) " + 0 + " Out Of " + marksdata1[options.question.name];
            totmarks = totmarks + parseInt(marksdata1[options.question.name]);

          }
        }
        return new Promise<void>(function (resolve) {
          options.point.xLeft += options.controller.unitWidth;
          options.point.yTop += options.controller.unitHeight;
          point.xLeft += options.controller.unitWidth + 400; //PDF score left position
          point.yTop += options.controller.unitHeight - 10;  //pdf score top position
          SurveyPDF
            .SurveyHelper
            .createDescFlat(point, options.question, options.controller, dataval)
            .then(function (descBrick) {
              options
                .bricks
                .push(descBrick);
              resolve();
            });
        });
      })
    function saveSurveyToPdf(filename, surveyModel, saveType, pdfWidth, pdfHeight) {
      if (saveType === "saveAsFile") {
        surveyPDF.save(filename);
      }
    }
    if (this.router.url.includes('std')) {
      document
        .getElementById("saveAsFileBtn")
        .onclick = function () {
          var pdfWidth = surveyModel.pdfWidth || 210;
          var pdfHeight = surveyModel.pdfHeight || 297;
          var studname = sessionStorage.getItem('stdnmm');
          console.log(surveyModel.data);
          saveSurveyToPdf(studname + ".pdf", surveyModel.data, "saveAsFile", pdfWidth, pdfHeight);
        };
    }
    //Before Changes
    function saveSurveyToExcel(studentName, filename, surveyModel, saveType, marksdata1, jsonData) {
      const surveyDataArray = [];
      const jsonDataProcessed = JSON.parse(jsonData);
      const pages = jsonDataProcessed.pages || [];

      const questionElements = pages[0].elements;
      console.log(questionElements);

      for (const element of questionElements) {
        let question = '';
        if (element.name && (element.title==''||element.title==undefined||element.title==null)) {
          question = element.name;
        } else if (element.title) {
          question = element.title;
        }
        const questionScore = marksdata1[element.name] || 0;//make it question if it does not work
        const correctAnswer = element.correctAnswer || '';

        let response = '';
        let obtainedMarks = 0;
        let formattedResponse = '';
        let isCorrect = false;

        if (surveyModel.data.hasOwnProperty(element.name)) {//Change to question if not working
          response = surveyModel.data[element.name];//Change to question if not working

          if (Array.isArray(response) && Array.isArray(correctAnswer)) {
            const selectedCorrectOptions = response.filter((option) => correctAnswer.includes(option));
            const selectedIncorrectOptions = response.filter((option) => !correctAnswer.includes(option));

            if (selectedCorrectOptions.length === correctAnswer.length && selectedIncorrectOptions.length === 0) {
              isCorrect = true;
              obtainedMarks = questionScore;
            }
          } else if (typeof response === 'object' && typeof correctAnswer === 'object') {
            isCorrect = compareObjects(response, correctAnswer);
            obtainedMarks = isCorrect ? questionScore : 0;
          } else {
            isCorrect = response === correctAnswer;
            obtainedMarks = isCorrect ? questionScore : 0;
          }

          formattedResponse = formatAnswer(response);
        } else {
          obtainedMarks = 0;
          formattedResponse = 'Not Attempted';
        }

        const formattedCorrectAnswer = Array.isArray(correctAnswer)
          ? correctAnswer.map((item) => formatAnswer(item)).join(', ')
          : formatAnswer(correctAnswer);

        surveyDataArray.push({
          StudentName: studentName,
          QuestionScore: questionScore,
          Question: question,
          Answer: formattedResponse,
          CorrectAnswer: formattedCorrectAnswer,
          ObtainedMarks: obtainedMarks,
        });
      }

      const worksheetData = surveyDataArray.map((response) => {
        const studentResponse = Array.isArray(response.Answer) ? response.Answer.join(', ') : response.Answer;
        return {
          "Student Name": response.StudentName,
          "Question Score": response.QuestionScore,
          Question: response.Question,
          Answer: response.CorrectAnswer,
          "Student Response": studentResponse,
          "Obtained Score": response.ObtainedMarks,
          // Add more properties as needed for each column in the Excel sheet
        };
      });

      const worksheet = XLSX.utils.json_to_sheet(worksheetData);
      const headers = Object.keys(worksheetData[0]);
      XLSX.utils.sheet_add_json(worksheet, worksheetData, { header: headers, skipHeader: false });
      const workbook = { Sheets: { Responses: worksheet }, SheetNames: ['Responses'] };

      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      const blob = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
      });

      saveAs(blob, filename + '.xlsx');
    }
    // Function to format key-value pairs
    function formatKeyValuePairs(obj) {
      const pairs = [];
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          pairs.push(`${key}:${obj[key]}`);
        }
      }
      return pairs.join(', ');
    }

    // Function to format the Answer
    function formatAnswer(answer) {
      if (typeof answer === 'object' && !Array.isArray(answer)) {
        const formattedAnswer = [];
        for (const key in answer) {
          if (answer.hasOwnProperty(key)) {
            formattedAnswer.push(`${key}:${answer[key]}`);
          }
        }
        return formattedAnswer.join(', ');
      } else if (answer === '') {
        return 'Not Answered';
      }
      return answer;
    }

    // Function to compare two objects
    function compareObjects(obj1, obj2) {
      const keys1 = Object.keys(obj1);
      const keys2 = Object.keys(obj2);

      if (keys1.length !== keys2.length) {
        return false;
      }

      for (let i = 0; i < keys1.length; i++) {
        const key = keys1[i];
        if (obj1[key] !== obj2[key]) {
          return false;
        }
      }

      return true;
    }

    if (this.router.url.includes('std')) {
      const json = this.json;
      console.log(this.json);
      document.getElementById('saveAsExcelBtn').onclick = function () {
        var studname = sessionStorage.getItem('stdnmm');
        saveSurveyToExcel(studname, "Export_" + studname, surveyModel, "saveAsFile", marksdata1, json);
      };
    }


    //End

    setTimeout(function () {
      Survey.SurveyNG.render("surveyElement", { model: surveyModel });

    }, 500);

  }


  calculatemarks(json, result) {
    var JsonArray = [];
    console.log("JSON" + JSON.stringify(json));
    for(var PageKey in json.pages)
    {
    if(result==undefined)
    {
      for(var Jkey in json.pages[PageKey].elements)
      {
        this.marks1[json.pages[PageKey].elements[Jkey].name] =json.pages[PageKey].elements[Jkey].Marks;
        this.totquizscore =this.totquizscore +parseInt(json.pages[PageKey].elements[Jkey].Marks);//
      }
    }
    
    for (var key in result) {
      for(var Jkey in json.pages[PageKey].elements)
    { 
       var marks = [];
      if(json.pages[PageKey].elements[Jkey].name!=key || key==undefined)
      {
        this.marks1[json.pages[PageKey].elements[Jkey].name] =json.pages[PageKey].elements[Jkey].Marks;
        this.totquizscore =this.totquizscore +parseInt(json.pages[PageKey].elements[Jkey].Marks);//
      }
      else if (JSON.parse(JSON.stringify(json))["pages"][0]["elements"][(parseInt(key.split("question")[1]) - 1)]["Marks"] != undefined&&JSON.parse(JSON.stringify(json))["pages"][0]["elements"][(parseInt(key.split("question")[1]) - 1)]["Marks"] != null) {
        this.marks1[key] = JSON.parse(JSON.stringify(json))["pages"][0]["elements"][(parseInt(key.split("question")[1]) - 1)]["Marks"];
        this.totquizscore = this.totquizscore + parseInt(JSON.parse(JSON.stringify(json))["pages"][0]["elements"][(parseInt(key.split("question")[1]) - 1)]["Marks"])
      }
      else 
      {
          this.marks1[key] = 1;
          this.totquizscore = this.totquizscore + 1;
      }
      
    }
  }
    };
    console.log(this.marks1)
    return this.marks1;
  }

 getType(p) {
    if (Array.isArray(p)) return 'array';
    else if (typeof p == 'string') return 'string';
    else if (p != null && typeof p == 'object') return 'object';
    else return 'other';
}
//Updated for Empty Answers and also displaying marks
  //calculatemarks1(json, result) {
  //  if (this.getType(json) !== 'object') {
  //    json = JSON.parse(json);
  //  }

  //  this.totquizscore = 0;
  //  //this.marks1 = {};

  //  // Loop through all questions in the survey
  //  for (var i = 0; i < json.pages[0].elements.length; i++) {
  //    var element = json.pages[0].elements[i];
  //    var key = element.name;

  //    // If there is an answer for this question, calculate the marks
  //    if (result[key] !== undefined) {
  //      var marks = parseInt(element.Marks) || 1;//
  //      this.marks1[key] = marks;
  //      this.totquizscore += (result[key] == element.correctAnswer) ? marks : 0;
  //    }
  //    // If there is no answer, assume it is incorrect and subtract maximum marks
  //    else {
  //      var marks = parseInt(element.Marks) || 1;//
  //      this.marks1[key] = marks;
  //      this.totquizscore -= marks;
  //    }
  //  }

  //  console.log(this.marks1);
  //  return this.marks1;
  //}
  calculatemarks1(json, result) {
    if (this.getType(json) !== 'object') {
      json = JSON.parse(json);
    }

    this.totquizscore = 0;
    //this.marks1 = {};
    this.marks1 = [];
    // Loop through all questions in the survey
    for (var i = 0; i < json.pages[0].elements.length; i++) {
      var element = json.pages[0].elements[i];
      var key = element.name;

      // If there is an answer for this question, calculate the marks
      if (result[key] !== undefined) {
        var marks = parseInt(element.Marks) || 1;//
        this.marks1[key] = marks;
        console.log(result[key]===element.correctAnswer)
        this.totquizscore += (result[key] == element.correctAnswer) ? marks : 0;
      }
      // If there is no answer, assume it is incorrect and subtract maximum marks
      else {
        var marks = parseInt(element.Marks) || 1;//
        this.marks1[key] = marks;
        this.totquizscore -= marks;
      }
    }

    console.log(this.marks1);
    return this.marks1;
  }

// calculatemarks1(json, result) {
//   if(this.getType(json)!='object')
//   {
  
//   const jsonsVar=JSON.parse(json);
  
 
//   for (var key in result) 
//   {
//     var marks = [];
//     for(let i in jsonsVar.pages)
//    { 
//     if(result==undefined)
//     {
//       for(var Jkey in jsonsVar.pages[i].elements)
//       {
//         this.marks1[jsonsVar.pages[i].elements[Jkey].name] =json.pages[i].elements[Jkey].Marks;
//         this.totquizscore =this.totquizscore +json.pages[i].elements[Jkey].Marks;
//       }
//     }
//       for(var j in json.pages[i].elements)
//       {
       
//         if(jsonsVar.pages[i].elements[j].name!=key|| key==undefined)
//         {
//           this.marks1[jsonsVar.pages[i].elements[j].name] =jsonsVar.pages[i].elements[j].Marks;
//       this.totquizscore =this.totquizscore +jsonsVar.pages[i].elements[j].Marks;
//         }
//         else if (JSON.parse(json)["pages"][0]["elements"][(parseInt(key.split("question")[1]) - 1)]["Marks"] != undefined) {
//           this.marks1[key] = JSON.parse(json)["pages"][0]["elements"][(parseInt(key.split("question")[1]) - 1)]["Marks"];
//           this.totquizscore = this.totquizscore + parseInt(JSON.parse(json)["pages"][0]["elements"][(parseInt(key.split("question")[1]) - 1)]["Marks"])
//         }
//         else {
//           this.marks1[key] = 1;
//           this.totquizscore = this.totquizscore + 1;
//         }
//       }
//    }
//   };
   
    
  
    
//   }
//   else
//   {
//     for (var key in result) 
//     {
//       var marks = [];
//     if (JSON.parse(json)["pages"][0]["elements"][(parseInt(key.split("question")[1]) - 1)]["Marks"] != undefined) {
//       this.marks1[key] = JSON.parse(json)["pages"][0]["elements"][(parseInt(key.split("question")[1]) - 1)]["Marks"];
//       this.totquizscore = this.totquizscore + parseInt(JSON.parse(json)["pages"][0]["elements"][(parseInt(key.split("question")[1]) - 1)]["Marks"])
//     }
//     else {
//       this.marks1[key] = 1;
//       this.totquizscore = this.totquizscore + 1;
//     }
//   }
//   }

//   console.log(this.marks1);
//   return this.marks1;
// }
  //saveSurveyToPdf(filename, surveyModel, saveType, pdfWidth, pdfHeight) {

  //  var options = {
  //    fontSize: 14,
  //    margins: {
  //      left: 10,
  //      right: 10,
  //      top: 10,
  //      bot: 10,
  //      compress: Boolean,
  //      commercial: true
  //    },
  //    format: [pdfWidth, pdfHeight]
  //  };
  //  const surveyPDF = new SurveyPDF.SurveyPDF(this.json, options);
  //  surveyPDF.mode = "display";
  //  surveyPDF.data = surveyModel.data;
  //  setTimeout(function () {
  //    surveyPDF.data = surveyModel.data;
  //    surveyPDF.save("filename");
  //  }, 500);

  //}
  saveSurveyToPdf(filename, surveyModel, saveType, pdfWidth, pdfHeight) {
    var options = {
      fontSize: 14,
      margins: {
        left: 10,
        right: 10,
        top: 10,
        bot: 10,
        compress: Boolean,
        commercial: true
      },
      format: [pdfWidth, pdfHeight]
    };

    const surveyPDF = new SurveyPDF.SurveyPDF(this.json, options);
    surveyPDF.mode = "display";

    const caseInsensitiveData = {};

    // Convert data keys to lowercase and store in caseInsensitiveData
    for (const key in surveyModel.data) {
      caseInsensitiveData[key] = surveyModel.data[key].toLowerCase();
    }

    setTimeout(function () {
      surveyPDF.data = caseInsensitiveData; // Use the case-insensitive data object
      surveyPDF.save(filename);
    }, 500);
  }

}
